import _ from 'lodash';
import { UAParser } from 'ua-parser-js';

type Browser = {
  name: string | undefined;
  version: string | undefined;
  major: string | undefined;
};

export type Device = {
  model: string | undefined;
  type: string | undefined;
  vendor: string | undefined;
};

type Engine = {
  name: string | undefined;
  version: string | undefined;
};

type OS = {
  name: string | undefined;
  version: string | undefined;
};

type CPU = {
  architecture: string | undefined;
};

export type UAParserResult = {
  ua: string;
  browser?: Browser;
  device?: Device;
  engine?: Engine;
  os?: OS;
  cpu?: CPU;
};

const MOBILE_SAFARI = 'Mobile Safari';

const getOS = (uaInfo: UAParserResult): Device['type'] => {
  return _.get(uaInfo, 'os.name');
};

const getIsAndroid = (uaInfo: UAParserResult): boolean => {
  return getOS(uaInfo) === 'Android';
};

const getIsIOS = (uaInfo: UAParserResult): boolean => {
  return getOS(uaInfo) === 'iOS';
};

const getIsMobile = (uaInfo: UAParserResult) => {
  const type: Device['type'] = _.get(uaInfo, 'device.type');

  return type === 'mobile' || type === 'tablet';
};

const initUAInfo = () => {
  const uaInfo: UAParserResult = new UAParser().getResult();

  const isAndroid: boolean = getIsAndroid(uaInfo);

  const isIOS: boolean = getIsIOS(uaInfo);

  const isMobile: boolean = getIsMobile(uaInfo);

  const deviceInfo = { isAndroid, isIOS, isMobile };

  const getDeviceInfo = () => ({ ...deviceInfo });

  return { getDeviceInfo };
};

const uaInfo = initUAInfo();

export const getDeviceInfo = () => {
  return uaInfo.getDeviceInfo();
};
